const MODAL_KEY = "resolute-modal";

const setViewedModal = () => {
    localStorage.setItem(MODAL_KEY, new Date().toISOString());
};

const getViewedModal = () => {
    const lastOpenedDate = new Date(localStorage.getItem(MODAL_KEY));
    if (lastOpenedDate) {
        const today = new Date();
        const diffTime = Math.abs(today - lastOpenedDate);
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

        return 7 >= diffDays;
    }

    return false;
};

const LocalStorageService = {
    getViewedModal,
    setViewedModal,
};
export default LocalStorageService;
